/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography, useTheme } from '@material-ui/core'
import styles from './VNCharity.module.scss'
import cn from 'classnames'
import { useEffect, useState } from 'react'
import { VNButtonContainer } from '../components/VNButtonContainer'
import { centsToDollars, centsToFixedDollars } from '../../utils/formatters'
import VNBottomButton from '../../components/VNBottomButton'
import { getNextDollar, transformCharityOptions } from '../../utils/charityConfig'
import { getInitializedValues } from '../Selectors'
import { useDispatch, useSelector } from 'react-redux'
import { useVnPayment } from '../hooks/useProcessPayment'
import { setVNTipEntryDialog } from '../../VNDialogs/ActionCreators'
import { isEmpty } from 'lodash'

export const VNCharity = () => {
  const classNames = cn(styles.charity)
  const theme = useTheme()
  const dispatch = useDispatch()
  const [donationId, setDonationId] = useState(null)
  const [donationAmount, setDonationAmount] = useState(0)

  // used for testing
  // const charityOptions = [
  //   {
  //     title: '$1',
  //     price: 100,
  //   },
  //   {
  //     title: '$5',
  //     price: 500,
  //   },
  //   {
  //     title: '$10',
  //     price: 1000,
  //   },
  //   {
  //     isCustom: true,
  //     price: null,
  //     title: 'Custom',
  //   },
  // ]

  const charitySettings = useSelector((state) => getInitializedValues(state))?.get('charitySettings')

  const { getTotalInCents, handlePaymentClick } = useVnPayment()

  const charityOptions = charitySettings?.charityOptions || []
  const charityTitle = charitySettings?.charityName || ''
  const charityDescription = charitySettings?.charityDescription || ''
  const optionsEnabled = charitySettings?.charityOptionsEnabled === 'true' || false
  const roundUpEnabled = charitySettings?.roundUpForCharityEnabled === 'true' || false
  const charityImage = charitySettings?.charityImage || ''

  const [donations, setDonations] = useState([])
  const [charityOptionsEnabled, setCharityOptionsEnabled] = useState(false)

  useEffect(() => {
    if (isEmpty(charityOptions) && roundUpEnabled) {
      setCharityOptionsEnabled(false)
      return
    }

    setCharityOptionsEnabled(optionsEnabled)
    setDonations(transformCharityOptions(charityOptions))
  }, [charitySettings])

  const onButtonContainerClick = (button) => {
    const id = button?.id

    if (id === 'custom') {
      // open custom donation screen
      dispatch(
        setVNTipEntryDialog(
          true,
          (donationAmountInCents) => {
            setDonationAmount(donationAmountInCents)
            dispatch(setVNTipEntryDialog(false))
            setDonationId(id)
          },
          donationId === id ? donationAmount : 0,
          'Custom Donation',
          false,
          'Save',
          true,
        ),
      )
      return
    }

    const donationAmountInCents = donations.find((donation) => donation.id === id)?.amount || 0
    setDonationAmount(donationAmountInCents)
  }

  const displayFixedDonations = () => {
    let tipDisplayArray = [[]]

    donations.forEach((donation) => {
      tipDisplayArray[0].push(donation)
    })

    return (
      <Box className={styles.donationContainer}>
        <VNButtonContainer
          buttonStyle={styles.containerButton}
          onClick={onButtonContainerClick}
          defaultSelected={false}
          buttons={tipDisplayArray}
        />
      </Box>
    )
  }

  const onConfirm = (donation = null) => {
    let amount = donation ?? donationAmount
    if (roundUpEnabled && !charityOptionsEnabled && donation === null) {
      amount = getNextDollar(getTotalInCents())
    }

    handlePaymentClick(amount)
  }

  const donationText = () => {
    if (roundUpEnabled && !charityOptionsEnabled) {
      return `Round Up ${centsToFixedDollars(getNextDollar(getTotalInCents()))}`
    }

    return `Donate ${centsToFixedDollars(donationAmount)}`
  }

  const getCartTotal = () => {
    if (roundUpEnabled && !charityOptionsEnabled) {
      return centsToDollars(getTotalInCents() + getNextDollar(getTotalInCents()))
    }

    return centsToDollars(getTotalInCents() + donationAmount)
  }

  return (
    <div className={classNames}>
      <div className={styles.topTextContainer}>
        <Typography style={theme.custom.large1}>
          {charityOptionsEnabled ? 'Support a cause?' : 'Round up to support a cause?'}
        </Typography>
        <Typography className={styles.totalText} style={theme.custom.subtitle3}>
          Total: {getCartTotal()}
        </Typography>
      </div>
      <div className={styles.charityContainer}>
        {charityOptionsEnabled && displayFixedDonations()}
        <div className={cn(styles.centerColumn, { [styles.optionsEnabled]: charityOptionsEnabled })}>
          {charityImage && <img src={charityImage} alt="" className={styles.charityImage} />}
          {!charityImage && charityTitle && (
            <Typography variant="h3" className={styles.charityText}>
              {charityTitle}
            </Typography>
          )}
          {charityDescription && (
            <Typography style={theme.custom.subtitle3} className={styles.charitySubtext}>
              {charityDescription}
            </Typography>
          )}
        </div>
        <div className={styles.bottomButtonContainer}>
          <VNBottomButton text={'No Thanks'} onClick={() => onConfirm(0)} className={styles.noThanksButton} />
          <VNBottomButton text={donationText()} onClick={() => onConfirm(null)} className={styles.donateButton} />
        </div>
      </div>
    </div>
  )
}
